import * as React from 'react'
import sanitizeHtml from 'sanitize-html'

import { ChevronRightIcon } from '@heroicons/react/20/solid'
import { Disclosure, Transition } from '@headlessui/react'

function TailwindAccordion({ item }: { item: AccordionItemI }) {
  return (
    <Disclosure
      as="div"
      className={`bg-dark-8 transition-all last:rounded-bl-card last:rounded-br-card first:rounded-tl-card first:rounded-tr-card`}
    >
      {({ open }) => (
        <>
          <Disclosure.Button
            className={`${
              open ? 'rounded-bl-none rounded-br-none' : ''
            } py-4 px-6 pl-4 text-left flex w-full bg-dark-6 hover:bg-dark-5 rounded-md transition-all text-[#fff]`}
          >
            <ChevronRightIcon
              aria-hidden="true"
              className={`${
                open ? 'rotate-90 transform' : ''
              } h-7 w-7 -translate-y-0.25 text-gray-6 transition-transform`}
            />
            {item.title}
          </Disclosure.Button>

          <Transition
            enter="transition duration-300 ease-out"
            enterFrom="transform translate-x-3 opacity-0"
            enterTo="transform translate-x-0 opacity-100"
            leave="transition duration-75 ease-out"
            leaveFrom="transform translate-x-2 opacity-100"
            leaveTo="transform translate-x-3 opacity-0"
          >
            <Disclosure.Panel
              dangerouslySetInnerHTML={{ __html: sanitizeHtml(item.content) }}
              className=" text-gray-5 text-base pt-6 -mt-3 px-6 pb-6"
            />
          </Transition>
        </>
      )}
    </Disclosure>
  )
}

interface AccordionItemI {
  title: string
  content: string
  id: string
}

interface DewiAccordionProps {
  items: AccordionItemI[]
}

function DewiAccordion({ items }: DewiAccordionProps) {
  return (
    <div className="space-y-1">
      {items.map((item) => (
        <TailwindAccordion key={item.id} item={item} />
      ))}
    </div>
  )
}

export { DewiAccordion }
